"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickOrderTab = void 0;
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const menu_1 = require("client/components/menu");
const modal_1 = require("client/components/modal");
const router_1 = require("client/components/router");
const distributor_drop_down_override_1 = require("client/modules/inventory-order/components/distributor-drop-down-override");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/inventory/modules/inventory-list/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/store");
const store_5 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const jwt_1 = require("server/jwt");
const po_email_template_1 = require("shared/po-email-template");
const uppercase_string_1 = require("shared/util/uppercase-string");
const throttle_debounce_1 = require("throttle-debounce");
const distributor_shipping_option_1 = require("./components/distributor-shipping-option");
const quick_order_scan_1 = require("./components/quick-order-scan");
require("./quick-order.less");
const store_6 = require("client/modules/sites/modules/sites-detail/store"); //C-036.1
const permissions_1 = require("shared/permissions"); //C-036.1
const confirmation_modal_1 = require("client/components/confirmation-modal"); //Update to Where Pop Up is Associated C-046.20611
const columns = [
    {
        label: "ndc",
        id: "pkg"
    },
    {
        label: "name",
        id: "name"
    },
    {
        label: "pkg qty/form",
        id: "description"
    },
    {
        label: "suggested qty",
        id: "quantity"
    },
    {
        label: "order quantity",
        id: "quantity"
    }
];
const orderPreviewColumns = [
    {
        label: "qty",
        id: "qty"
    },
    {
        label: "ndc",
        id: "ndc"
    }
];
const orderReviewColumnsTmp = [
    {
        label: "ndc pkg",
        id: "ndcpackage"
    },
    {
        label: "name",
        id: "name"
    },
    {
        label: "description",
        id: "description"
    },
    {
        label: "qty on hand",
        id: "qty-on-hand"
    },
    {
        label: "min",
        id: "min"
    },
    {
        label: "max",
        id: "max"
    },
    {
        label: "distributor",
        id: "distributor"
    },
    {
        label: "price",
        id: "price"
    },
    {
        label: "order quantity",
        id: "quantity"
    },
    {
        label: "total cost",
        id: "total"
    }
];
const orderReviewColumns = [
    {
        label: "ndc pkg",
        id: "ndcpackage"
    },
    {
        label: "name",
        id: "name"
    },
    {
        label: "description",
        id: "description"
    },
    {
        label: "qty on hand",
        id: "qty-on-hand"
    },
    {
        label: "min",
        id: "min"
    },
    {
        label: "max",
        id: "max"
    },
    {
        label: "distributor",
        id: "distributor"
    },
    {
        label: "order quantity",
        id: "quantity"
    }
];
let QuickOrderTab = class QuickOrderTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.filterText = "";
        this.showMenu = false;
        this.orderInventory = {};
        this.orderSuggested = {};
        this.orderReview = {};
        this.quickSearchSelection = null;
        this.quickSearchQuantity = "";
        this.showOrderReview = false;
        this.selectedDistributor = null;
        this.distributorInventoryPrices = {};
        // @observable
        this.inventoryDistributorSelection = {};
        this.inventoryPrices = {};
        this.inventoryImbCosts = {};
        this.attachANote = false;
        this.orderTotalCost = 0;
        this.orderTotalCostDefault = 0;
        this.total = {};
        this.currentCart = [];
        this.orderDistributorSelection = {};
        this.orderNote = "";
        this.associatedSiteUserEmail = []; // C-036.1 new
        this.orderName = "";
        this.orderDescription = "";
        this.transactionPONumber = "";
        this.orderSiteId = 0; // so IMB users can select pharmacy to make order for.
        this.automateOrderUsed = false;
        this.showAutomateOrderConfirmation = false;
        this.purchaseOrderIntents = [];
        this.shippingMethods = [];
        this.showQuickOrderScan = false;
        //C-090
        this.totalQuantity = 0;
        this.showConfirmApproveDoubleChecks = false; //Update to Where Pop Up is Associated C-046.20611
        // C-046.207_UAT
        this.isDistributor = false; // lavk2
        //ashwani
        this.storeMissingdistInvt = []; // Update to Where Pop Up is Associated C-046.2061 
        //ashwani
        this.htmlDataForMessage = []; // Update to Where Pop Up is Associated C-046.2061 
        //
        this.isDistributorAssisgnedInvt = false;
        this.loadInventories = throttle_debounce_1.debounce(200, async () => {
            await store_2.inventoryListStore.loadInventory({
                count: 1000,
                start: 0,
                // where: this.orderSiteId
                //   ? `inventorysite.siteId = ${this.orderSiteId} AND inventorysite.active = true AND inventory.isBackorder = false`
                //   : "inventory.isBackorder = false"
                where: this.orderSiteId
                    ? `inventorysite.siteId = ${this.orderSiteId} AND inventorysite.active = true`
                    : ""
            });
        });
        this.initializeGenerateIntentQuickOrder = () => {
            const { claim, inventory, claimQuantity, site } = store_1.inventoryOrderStore.intentOrderMeta;
            const inventorySiteFound = inventory.sites &&
                inventory.sites.find(invsite => invsite.siteId === site.id);
            if (inventorySiteFound && inventorySiteFound.active) {
                this.orderReview[inventory.id] = {
                    inventory,
                    quantity: String(claimQuantity)
                };
                this.orderInventory[inventory.id] = String(claimQuantity);
                this.orderReview = Object.assign({}, this.orderReview);
            }
            else {
                // actionlog reason why didn't populate.
                const noInventorySite = !inventorySiteFound;
                const inventorySiteNotActive = inventorySiteFound && !inventorySiteFound.active;
                const logData = {
                    user: store_5.usersStore.user.value.id,
                    action: `Generate inventory order for intent claim. ${noInventorySite
                        ? `inventory ${inventory.strengthDescription} not found in ${site.name}`
                        : inventorySiteNotActive
                            ? `${inventory.strengthDescription} not active in ${site.name}`
                            : "<never>"}`,
                    category: store_5.LogCategory.claim,
                    categoryReferenceKey: claim.id,
                    site: site.id,
                    order: claim.orderId || (claim.order && claim.order.id) || null
                };
                store_4.auditLoggerStore.auditLog(logData);
            }
        };
        this.loadPurchaseOrderIntents = async () => {
            await store_1.inventoryOrderStore.loadPurchaseOrderIntents(this.orderSiteId);
            this.purchaseOrderIntents = store_1.inventoryOrderStore.purchaseOrderIntents;
            this.initializeSuggestedQty();
        };
        this.handleShippingOptionsChange = (shippingMethods) => {
            this.shippingMethods = shippingMethods;
        };
        this.initiatePoEdit = () => {
            this.orderReview = {};
            this.orderInventory = {};
            const purchaseOrderToEdit = store_1.inventoryOrderStore.purchaseOrderToEdit;
            if (purchaseOrderToEdit) {
                const { orderName, note, orderDescription, orderInventories, shippingMethods = [] } = purchaseOrderToEdit;
                this.orderName = orderName || "";
                this.orderDescription = orderDescription || "";
                this.orderNote = note || "";
                this.attachANote = this.orderNote ? true : false;
                this.shippingMethods = shippingMethods;
                if (orderInventories) {
                    for (const orderInventory of orderInventories) {
                        const { inventory, inventorySite } = orderInventory;
                        if (inventorySite && inventorySite.active) {
                            this.orderReview[inventory.id] = {
                                inventory,
                                quantity: String(orderInventory.inventoryOrderQuantity)
                            };
                            this.orderInventory[inventory.id] = String(orderInventory.inventoryOrderQuantity);
                            this.orderReview = Object.assign({}, this.orderReview);
                        }
                    }
                }
            }
        };
        // get availableOptions() {
        //   return sitesListStore.sites.value
        //     ? sitesListStore.sites.value.map((site, i) => ({
        //         id: i,
        //         label: site.displayName || site.name,
        //         value: site.id.toString()
        //       }))
        //     : [];
        // }
        this.renderQuickOrder = () => {
            const { purchaseOrderToEdit } = store_1.inventoryOrderStore;
            return (React.createElement("div", { className: "inventory-order__quick-order" },
                React.createElement("div", { className: "edit-order-header" },
                    !!purchaseOrderToEdit ? (React.createElement("div", null,
                        React.createElement(core_1.Typography, { variant: "display1" }, "Edit Mode"),
                        React.createElement(core_1.Typography, { variant: "subheading" }, `Transaction#: ${purchaseOrderToEdit.transactionPONumber}`))) : null,
                    React.createElement("div", { className: "edit-order-header__main" },
                        React.createElement(select_1.MaterialSelect, { className: "edit-order-header__select-site", options: this.availableOptions, required: true, disabled: !!purchaseOrderToEdit, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.orderSiteId) || "" }),
                        React.createElement("div", { className: "edit-order-header__search" },
                            React.createElement(menu_1.Menu, { data: this.renderFilteredData(), showMenu: this.showMenu, onAction: this.handleOnMenuAction },
                                React.createElement(text_field_1.MaterialTextField, { className: "product-search-field", label: "Search product", value: this.filterText, onChange: this.handleSearch(), onBlur: () => (this.showMenu = false) })),
                            React.createElement(menu_1.Menu, { data: [], showMenu: false, onAction: () => {
                                    // empty
                                } },
                                React.createElement(text_field_1.MaterialTextField, { label: "Quantity", value: this.quickSearchQuantity, onChange: this.handleQuickSearchQuantityChange, className: "quantity-input" })),
                            React.createElement(button_1.MaterialButton, { className: "edit-order-button", secondary: true, onClick: this.handleAddToOrder }, "Add to order"),
                            React.createElement(button_1.MaterialButton, { className: "edit-order-button", secondary: true, onClick: () => (this.showQuickOrderScan = true) }, "Scan"))),
                    React.createElement("div", { className: "edit-order-header__buttons" },
                        React.createElement(button_1.MaterialButton, { className: "edit-order-button", flat: true, disabled: !!purchaseOrderToEdit, secondary: true, onClick: this.handleAutomateOrderClick }, !this.automateOrderUsed
                            ? "Automate Order Qty"
                            : "Clear Automated Qty"),
                        React.createElement(button_1.MaterialButton, { className: "edit-order-button edit-order-button__reset", flat: true, disabled: !!purchaseOrderToEdit, onClick: this.resetQty }, "Reset"))),
                React.createElement(React.Fragment, null, this.renderOrderList())));
        };
        this.handleAutomateOrderClick = () => {
            if (this.automateOrderUsed) {
                this.clearAutomatedQty();
                this.automateOrderUsed = false;
            }
            else {
                this.showAutomateOrderConfirmation = true;
            }
        };
        this.resetQty = () => {
            this.orderReview = {};
            this.orderInventory = {};
            this.automateOrderUsed = false;
        };
        this.clearAutomatedQty = () => {
            for (const purchaseOrderIntent of this.purchaseOrderIntents) {
                const { inventory } = purchaseOrderIntent;
                if (this.orderReview[inventory.id]) {
                    delete this.orderReview[inventory.id];
                }
                if (this.orderInventory[inventory.id]) {
                    delete this.orderInventory[inventory.id];
                }
                this.orderReview = Object.assign({}, this.orderReview);
            }
        };
        this.automateOrder = () => {
            this.automateOrderUsed = true;
            for (const purchaseOrderIntent of this.purchaseOrderIntents) {
                const { qtyToOrder, inventory } = purchaseOrderIntent;
                this.orderReview[inventory.id] = {
                    inventory,
                    quantity: String(qtyToOrder > 0 ? qtyToOrder : 0) // default qtyToOrder to 0 if less than 0
                };
                this.orderInventory[inventory.id] = String(qtyToOrder > 0 ? qtyToOrder : 0);
                this.orderSuggested[inventory.id] = String(qtyToOrder > 0 ? qtyToOrder : 0);
                this.orderReview = Object.assign({}, this.orderReview);
            }
            this.showAutomateOrderConfirmation = false;
        };
        // C-090
        this.footer_style = {
            fontSize: 12,
            color: '#181818',
            fontWeight: "bold",
            fontFamily: 'inherit'
        };
        this.initializeSuggestedQty = () => {
            for (const purchaseOrderIntent of this.purchaseOrderIntents) {
                const { qtyToOrder, inventory } = purchaseOrderIntent;
                this.orderSuggested[inventory.id] = String(qtyToOrder > 0 ? qtyToOrder : 0);
            }
            this.forceUpdate();
        };
        this.getShippingOptions = () => {
            const distributorsSelected = Object.keys(ramda_1.groupBy(d => d, Object.values(this.orderDistributorSelection)));
            const { distributors } = store_1.inventoryOrderStore;
            const distributorShippingOptions = [];
            for (const distributorName of distributorsSelected) {
                const distributorFound = distributors.find(distributor => distributor.distributor === distributorName);
                if (distributorFound) {
                    const { shippingOptions = [] } = distributorFound;
                    const defaultShippingOption = shippingOptions && shippingOptions.find(option => option.isDefault);
                    const selectedShippingOption = this.shippingMethods.find(option => option.id === distributorFound.id);
                    distributorShippingOptions.push({
                        id: distributorFound.id,
                        distributor: distributorName,
                        shippingMethod: selectedShippingOption
                            ? selectedShippingOption.method
                            : defaultShippingOption
                                ? defaultShippingOption.method
                                : "",
                        shippingOptions
                    });
                }
            }
            return distributorShippingOptions;
        };
        this.renderOrderReviewPage = () => {
            const Label = (props) => (React.createElement("div", { className: "heading-group" },
                React.createElement(core_1.Typography, { variant: "body2" }, props.label),
                React.createElement(core_1.Typography, { variant: "body1" }, props.value)));
            const site = store_3.sitesListStore &&
                store_3.sitesListStore.sites &&
                store_3.sitesListStore.sites.value &&
                store_3.sitesListStore.sites.value.find((site) => site.id === this.orderSiteId);
            const pharmacyName = site ? site.name : "n/a";
            const { purchaseOrderToEdit } = store_1.inventoryOrderStore;
            const isRejected = purchaseOrderToEdit
                ? purchaseOrderToEdit.approvalStatus === "rejected"
                : false;
            return (React.createElement("div", { className: "inventory-order__quick-order" },
                React.createElement("div", { className: "review-order-header" },
                    React.createElement("div", { className: "review-order-header__heading" },
                        React.createElement(Label, { label: "Pharmacy Name", value: pharmacyName })),
                    React.createElement("div", { className: "review-order-header__actions" },
                        React.createElement("div", { className: "review-order-header__actions--content" },
                            React.createElement("div", { className: "review-order-header__actions--notes" },
                                React.createElement(switch_1.MaterialSwitch, { label: "Attach a note", value: "note", disabled: false, checked: this.attachANote, onChange: this.handleAttachANoteToggle }),
                                React.createElement("div", { className: "review-order-header__actions--left" },
                                    React.createElement(text_field_1.MaterialTextField, { label: "Order reference", className: "review-order-header__actions--order-name", value: this.orderName, onChange: this.handleOrderNameChange }),
                                    this.attachANote && (React.createElement("textarea", { onChange: this.handleOrderNoteChange, placeholder: "Add a note", value: this.orderNote, rows: 4, cols: 50 })))),
                            React.createElement("div", { className: "review-order-header__actions--shipping" },
                                React.createElement(distributor_shipping_option_1.DistributorShippingOption, { onShippingOptionsChange: this.handleShippingOptionsChange, distributors: this.getShippingOptions() }))),
                        React.createElement("div", { className: "review-order-header__actions--submit" },
                            React.createElement(button_1.MaterialButton, { onClick: () => {
                                    this.showOrderReview = false;
                                } }, "Edit"),
                            purchaseOrderToEdit ? (React.createElement(button_1.MaterialButton, { className: "review-order-header__actions--submit__approval-button", disabled: !this.doesAbideOrderRules(), primary: true, onClick: this.handleSubmitUpdate }, isRejected
                                ? "Resubmit For Approval"
                                : "Update Purchase Order")) : (React.createElement(button_1.MaterialButton, { className: "review-order-header__actions--submit__approval-button", disabled: !this.doesAbideOrderRules(), primary: true, onClick: this.handleSubmit }, "Submit for approval"))))),
                this.renderOrderReviewList(),
                store_5.usersStore.user.value.user ? (
                //C-090 for Quick ORDER
                React.createElement(list_item_1.MaterialListItem, { className: "order-list-item" },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { style: this.footer_style },
                            "Total:",
                            " ") }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { style: this.footer_style }, this.totalQtyCalculation() !== undefined && this.totalQtyCalculation() !== null
                            ? this.formatNumberOnly(this.totalQtyCalculation())
                            : "0.00") }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { style: this.footer_style }, this.orderTotalCost !== undefined && this.orderTotalCost !== null
                            ? this.formatNumber(this.orderTotalCost)
                            : "$0.00") }))) : null));
        };
        // TODO: Implement
        this.doesAbideOrderRules = () => true;
        this.renderPoIntentQtyList = () => this.purchaseOrderIntents.map((intent, index) => {
            const { inventory, qtyToOrder } = intent;
            return (React.createElement(core_1.TableRow, { key: index },
                React.createElement(core_1.TableCell, null, inventory ? inventory.package : ""),
                React.createElement(core_1.TableCell, null, inventory ? inventory.strengthDescription || inventory.name : ""),
                React.createElement(core_1.TableCell, null, qtyToOrder ? qtyToOrder : "0")));
        });
        this.renderAutomateOrderConfirmationModal = () => (React.createElement(modal_1.Modal, { onCancel: () => (this.showAutomateOrderConfirmation = false) },
            React.createElement(core_1.Typography, { variant: "headline" }, "Order Automation Confirmation"),
            React.createElement(core_1.Typography, { variant: "subheading" }, "The following inventory quantities will be used"),
            React.createElement("div", { className: "intent-table" },
                React.createElement(core_1.Table, null,
                    React.createElement(core_1.TableHead, { className: "intent-table__head" },
                        React.createElement(core_1.TableRow, { className: "intent-table__head-row" },
                            React.createElement(core_1.TableCell, { className: "intent-table__head-row__cell" }, "name"),
                            React.createElement(core_1.TableCell, { className: "intent-table__head-row__cell" }, "pkg"),
                            React.createElement(core_1.TableCell, { className: "intent-table__head-row__cell" }, "qty"))),
                    React.createElement(core_1.TableBody, { className: "intent-table__body" }, this.renderPoIntentQtyList()))),
            !(this.purchaseOrderIntents && this.purchaseOrderIntents.length) ? (React.createElement(core_1.Typography, { variant: "subheading", align: "center" }, "No available data for automating qty to order")) : null,
            React.createElement("div", { className: "modal-confirmation-btn-container" },
                React.createElement(button_1.MaterialButton, { className: "modal-confirmation-btn-container__btn", flat: true, onClick: () => (this.showAutomateOrderConfirmation = false) }, "Cancel"),
                this.purchaseOrderIntents && this.purchaseOrderIntents.length ? (React.createElement(button_1.MaterialButton, { className: "modal-confirmation-btn-container__btn", flat: true, primary: true, onClick: this.automateOrder }, "Automate Qty")) : null)));
        this.handleScanSubmit = (scannedMeta) => {
            for (const scan of scannedMeta) {
                const inventoryFound = this.inventoryList.find(inv => inv.package === scan.pkg);
                if (inventoryFound) {
                    this.orderInventory[inventoryFound.id] = String(scan.qty);
                    this.orderReview[inventoryFound.id] = {
                        inventory: inventoryFound,
                        quantity: String(scan.qty)
                    };
                }
            }
            this.showQuickOrderScan = false;
        };
        // Allow only number and max of 4 char.
        this.isValidQuantity = (value) => {
            const re = /\d/g;
            const lastChar = value.split("").pop();
            return (re.test(lastChar) && value.length < 5) || value === "";
        };
        this.handleSubmitUpdate = async () => {
            const { purchaseOrderToEdit } = store_1.inventoryOrderStore;
            const purchaseOrderInventories = [];
            const activeSiteId = this.orderSiteId;
            for (const inventoryId in this.orderReview) {
                if (this.orderReview.hasOwnProperty(inventoryId) &&
                    this.orderReview[inventoryId].quantity &&
                    this.orderReview[inventoryId].quantity !== "0") {
                    const { package: ndcPackage, name, description } = this.orderReview[inventoryId].inventory;
                    const quantity = this.orderReview[inventoryId].quantity
                        ? parseFloat(this.orderReview[inventoryId].quantity)
                        : 0;
                    const price = this.inventoryPrices[inventoryId];
                    const imbCost = this.inventoryImbCosts[inventoryId];
                    // Get siteInventory to get min, max, quantityOnHand for inventory from site
                    let siteInventory;
                    const currentInventory = this.currentCart.find((inventory) => inventory.id === parseInt(inventoryId, 10));
                    if (currentInventory) {
                        siteInventory = currentInventory.sites.find((site) => site.siteId === activeSiteId);
                    }
                    const orderInventory = {
                        pkgCode: ndcPackage,
                        inventorySiteId: siteInventory.id,
                        inventoryId: Number(inventoryId),
                        name,
                        description,
                        inventoryOrderQuantity: quantity,
                        price,
                        inventoryTotalCost: price * quantity,
                        inventoryTotalImbCost: imbCost * quantity,
                        distributor: this.orderDistributorSelection[parseInt(inventoryId, 10)],
                        min: siteInventory ? siteInventory.min : 0,
                        max: siteInventory ? siteInventory.max : 0,
                        quantityOnHand: siteInventory ? siteInventory.quantity : 0,
                        note: ""
                    };
                    purchaseOrderInventories.push(orderInventory);
                }
            }
            const orderTotalCost = purchaseOrderInventories.reduce((acc, curr) => acc + curr.inventoryTotalCost, 0);
            const site = store_3.sitesListStore &&
                store_3.sitesListStore.sites &&
                store_3.sitesListStore.sites.value &&
                store_3.sitesListStore.sites.value.find((site) => site.id === activeSiteId);
            const purchaseOrder = {
                id: purchaseOrderToEdit.id,
                pharmacyName: site ? site.displayName : "No pharmacy display name",
                orderName: this.orderName ? this.orderName : "",
                orderDescription: this.orderDescription ? this.orderDescription : "",
                transactionPONumber: this.transactionPONumber
                    ? this.transactionPONumber
                    : "",
                orderInventories: purchaseOrderInventories,
                orderTotalCost,
                note: this.attachANote ? this.orderNote : "",
                siteId: activeSiteId,
                shippingMethods: this.shippingMethods
            };
            const resubmission = purchaseOrderToEdit.approvalStatus === "rejected";
            await store_1.inventoryOrderStore.updatePurchaseOrder(purchaseOrder, resubmission);
            store_1.inventoryOrderStore.purchaseOrderToEdit = null;
            router_1.RouteManager.transitionTo(`/order/review/${purchaseOrderToEdit.id}`);
        };
        /**
         * Handle submit purchase order for approval
         */
        this.handleSubmit = async () => {
            var _a, _b, _c;
            const purchaseOrderInventories = [];
            const activeSiteId = this.orderSiteId;
            // Serialize purchaseOrderInventories by looping through this.orderReview
            // only add push inventory to purchaseOrderInventories array if inventory has quantity.
            for (const inventoryId in this.orderReview) {
                if (this.orderReview.hasOwnProperty(inventoryId) &&
                    this.orderReview[inventoryId].quantity &&
                    this.orderReview[inventoryId].quantity !== "0") {
                    const { package: ndcPackage, name, description } = this.orderReview[inventoryId].inventory;
                    const quantity = this.orderReview[inventoryId].quantity
                        ? parseFloat(this.orderReview[inventoryId].quantity)
                        : 0;
                    const price = this.inventoryPrices[inventoryId];
                    const imbCost = this.inventoryImbCosts[inventoryId];
                    // Get siteInventory to get min, max, quantityOnHand for inventory from site
                    let siteInventory;
                    const currentInventory = this.currentCart.find((inventory) => inventory.id === parseInt(inventoryId, 10));
                    if (currentInventory) {
                        siteInventory = currentInventory.sites.find((site) => site.siteId === activeSiteId);
                    }
                    const orderInventory = {
                        pkgCode: ndcPackage,
                        inventorySiteId: siteInventory.id,
                        inventoryId: Number(inventoryId),
                        name,
                        description,
                        inventoryOrderQuantity: quantity,
                        price,
                        inventoryTotalCost: price * quantity,
                        inventoryTotalImbCost: imbCost * quantity,
                        distributor: this.orderDistributorSelection[parseInt(inventoryId, 10)],
                        min: siteInventory ? siteInventory.min : 0,
                        max: siteInventory ? siteInventory.max : 0,
                        quantityOnHand: siteInventory ? siteInventory.quantity : 0,
                        note: ""
                    };
                    purchaseOrderInventories.push(orderInventory);
                }
            }
            const orderTotalCost = purchaseOrderInventories.reduce((acc, curr) => acc + curr.inventoryTotalCost, 0);
            const site = store_3.sitesListStore &&
                store_3.sitesListStore.sites &&
                store_3.sitesListStore.sites.value &&
                store_3.sitesListStore.sites.value.find((site) => site.id === activeSiteId);
            const purchaseOrder = {
                pharmacyName: site ? site.displayName : "No pharmacy display name",
                orderName: this.orderName ? this.orderName : "",
                orderDescription: this.orderDescription ? this.orderDescription : "",
                transactionPONumber: this.transactionPONumber
                    ? this.transactionPONumber
                    : "",
                orderInventories: purchaseOrderInventories,
                orderTotalCost,
                note: this.attachANote ? this.orderNote : "",
                siteId: activeSiteId,
                shippingMethods: this.shippingMethods
            };
            const siteApprovalEmailAdd = (_b = (_a = site === null || site === void 0 ? void 0 : site.settings) === null || _a === void 0 ? void 0 : _a.orderApprovalEmailAddress) === null || _b === void 0 ? void 0 : _b.value; //E-053
            // D-023
            const comapnyDetailsBySite = await store_1.inventoryOrderStore.loadSiteComapnyDetailsInfo(this.orderSiteId); // D-023
            let comapnyEmailAdd;
            if (comapnyDetailsBySite) {
                await comapnyDetailsBySite.map((approvalEmail) => {
                    comapnyEmailAdd = approvalEmail.CompanyApprovalOrderEmail;
                });
            } // D-023
            /**
             * clinicAdminAndManagerEmails = all users emails associted with pharmacy and have clinic admin and manager roles C-036.1
             */
            const clinicAdminAndManagerEmails = (_c = (this.associatedSiteUserEmail.length > 0
                ? this.associatedSiteUserEmail.join(";")
                : "")) !== null && _c !== void 0 ? _c : "";
            const isPOEmailAssociated = !comapnyEmailAdd && !siteApprovalEmailAdd
                ? "(ASSOCIATED EMAIL WAS NOT FOUND)"
                : ""; // D-023
            const savedOrder = await store_1.inventoryOrderStore.createPurchaseOrder(purchaseOrder);
            const associatesEmails = (comapnyEmailAdd && siteApprovalEmailAdd) ? `${comapnyEmailAdd}; ${siteApprovalEmailAdd}` : comapnyEmailAdd ? comapnyEmailAdd : siteApprovalEmailAdd; // E-053.11
            const byDefaultEmail = "support@integrativeaconsult.com"; // E-053
            const poEMails = associatesEmails || byDefaultEmail; // C-036.1 new E-053.11
            if (savedOrder) {
                // @tk use inventoryOrderStore to send an alert notifying order pending approval.
                await store_1.inventoryOrderStore.sendPurchaseOrderSubmissionAlert(savedOrder);
                const mailToEmail = `${poEMails}; ${clinicAdminAndManagerEmails}`; // D-023 E-053 C-036.1 new
                // const mailToEmail = "info@billogix.com";
                const emailToken = jwt_1.sign(mailToEmail);
                const purchaseOrderTable = po_email_template_1.buildPOTable(savedOrder, emailToken);
                const emailTemplate = po_email_template_1.getPOEmailTemplate("New PO Pending", "Purchase Order Pending Approval", purchaseOrderTable);
                const result = await store_1.inventoryOrderStore.sendEmailAlert(emailTemplate, savedOrder, mailToEmail, isPOEmailAssociated); // D-023
                if (!result || !result.success) {
                    alert("Error in sending email alert");
                    console.log("result ---", result && result.success);
                }
                // Update POIntent status
                // Update all statuses of "Pending" to "Awaiting Approval"
                if (this.automateOrderUsed) {
                    await store_1.inventoryOrderStore.updatePurchaseOrderIntents(activeSiteId, savedOrder.id);
                }
                router_1.RouteManager.transitionTo("/dashboard"); // route to dashboard on order submit.
            }
            else {
                alert("Error: purchase order was not saved to the database. \n Redirecting to the dashboard.");
                router_1.RouteManager.transitionTo("/dashboard"); // route to dashboard on order submit.
            }
        };
        /**
         * Handles the state of the filter text based on user input.
         */
        this.handleSearch = () => (event, value) => {
            this.showMenu = true;
            this.filterText = value;
        };
        /**
         * Set filterText to the label of the selected item, set the item selected to quickSearchSelection
         */
        this.handleOnMenuAction = (item) => {
            this.filterText = item.label;
            this.quickSearchSelection = item;
        };
        /**
         * Set constraint to only allow number inputs.
         */
        this.handleQuickSearchQuantityChange = (event, value) => {
            if (this.isValidQuantity(value)) {
                this.quickSearchQuantity = value;
            }
        };
        this.handleQuantityChange = (row) => (event) => {
            const { value } = event.target;
            if (this.isValidQuantity(value)) {
                this.orderInventory[row.id] = value;
                this.orderReview[row.id] = {
                    inventory: row,
                    quantity: value
                };
            }
            this.forceUpdate();
        };
        // C-090
        this.totalQtyCalculation = () => {
            return (this.totalQuantity = Object.entries(this.orderReview)
                .filter((item) => item[1].quantity !== "0" && item[1].quantity !== "")
                .reduce((acc, current) => acc + parseInt(current[1].quantity), 0));
        };
        this.handleTransactionPONumberChange = (event) => {
            this.transactionPONumber = event.currentTarget.value;
        };
        this.handleOrderNoteChange = (event) => {
            this.orderNote = event.currentTarget.value;
        };
        this.handleOrderNameChange = (event) => {
            this.orderName = event.currentTarget.value;
        };
        this.handleOrderDescriptionChange = (event) => {
            this.orderDescription = event.currentTarget.value;
        };
        this.handleChangeSite = async (id) => {
            this.orderSiteId = Number(id);
            this.orderReview = {}; // reset order review
            this.orderInventory = {}; // reset order inventory
            this.automateOrderUsed = false; // reset automateOrderUsed
            await this.loadInventories();
            await this.loadPurchaseOrderIntents();
            const { intentOrderMeta } = store_1.inventoryOrderStore;
            const shouldGenerateIntentOrder = intentOrderMeta &&
                intentOrderMeta.site &&
                intentOrderMeta.site.id === this.orderSiteId;
            if (shouldGenerateIntentOrder) {
                this.initializeGenerateIntentQuickOrder();
            }
        };
        /**
         * Initialize the prices for the inventory cart based on distributor auto selection
         */
        this.initializeDistributorSelection = async () => {
            for (const inventory of this.currentCart) {
                const activeSite = this.orderSiteId;
                let siteInventory = inventory.sites.find((site) => site.siteId === activeSite // Changed from inventoryListStore.activePharm
                );
                if (!siteInventory) {
                    siteInventory = await store_1.inventoryOrderStore.findInventorySite(activeSite, inventory.id);
                }
                if (!siteInventory) {
                    console.error(`Error initializing order cart -- inventorysite not found -- inventoryId ${inventory.id} siteId ${activeSite}`);
                    continue;
                }
                const { distributorInventoryPrices } = inventory;
                let distributorInventories = null;
                // Get default and override id
                const { defaultDistributorOverrideId: defaultOverrideId, defaultDistributorId: defaultId } = siteInventory;
                // IF DISTRIBUTOR IS NOT A SITE DISTRIBUTOR, FIND DISTRIBUTOR INVENTORY WITH LOWEST PRICE TO USE AS DEFAULT
                // IF DISTRIBUTOR INVENTORY FOR SITE DOES NOT EXISTS, SET TO EMPTY.
                const { siteDistributors: sdUnfiltered } = store_1.inventoryOrderStore;
                const siteDistributors = sdUnfiltered.filter(sd => {
                    const backorderIds = sd.distributor.purchaseInventoryDistributor
                        .filter(pid => pid.isBackorder === 1)
                        .map(pid => pid.inventoryId);
                    return !backorderIds.includes(inventory.id);
                });
                const defaultInSiteDistributors = siteDistributors.find((sd) => sd.distributor.id === defaultId);
                const overrideInSiteDistributors = siteDistributors.find((sd) => sd.distributor.id === defaultOverrideId);
                // Set the distributor inventory price  to get prices from
                // Check for override first otherwise check for default
                if (this.orderDistributorSelection[inventory.id]) {
                    const selectedSiteDistributorFound = siteDistributors.find(sd => sd.distributor.distributor ===
                        this.orderDistributorSelection[inventory.id]);
                    if (selectedSiteDistributorFound) {
                        const selectedDistributorId = selectedSiteDistributorFound.distributor.id;
                        distributorInventories =
                            distributorInventoryPrices[selectedDistributorId];
                    }
                }
                else if (defaultOverrideId && overrideInSiteDistributors) {
                    distributorInventories = distributorInventoryPrices[defaultOverrideId];
                    if (!this.orderDistributorSelection[inventory.id]) {
                        this.orderDistributorSelection[inventory.id] =
                            siteInventory.defaultDistributorOverrideName;
                    }
                }
                else if (defaultId && defaultInSiteDistributors) {
                    distributorInventories = distributorInventoryPrices[defaultId];
                    if (!this.orderDistributorSelection[inventory.id]) {
                        this.orderDistributorSelection[inventory.id] =
                            siteInventory.defaultDistributorName;
                    }
                }
                // Get the price for the current inventory using row.id
                const distributorInventoryFound = distributorInventories
                    ? distributorInventories.find((distributorInventory) => distributorInventory.inventory.id === inventory.id)
                    : null;
                // Set the distributor inventory price
                // Set to 0 if distributor inventory price not found
                this.inventoryPrices[inventory.id] = distributorInventoryFound
                    ? distributorInventoryFound.inventoryPrice
                    : 0;
                // Set the distributor imbCost
                // Set to 0 if distributor imbCost not found
                this.inventoryImbCosts[inventory.id] = distributorInventoryFound
                    ? distributorInventoryFound.imbCost
                    : 0;
            }
            this.calculateOrderTotalCost();
        };
        /**
         * Handle distributor selection override for each inventory distributor, map data and calculate orderTotalCost.
         */
        this.handleDistributorSelectionOverride = (selection) => {
            // CHECK TO MAKE SURE DISTRIBUTOR SELECTED IS PART OF SITE DISTRIBUTOR
            const { siteDistributors } = store_1.inventoryOrderStore;
            const distributorSelectedInSiteDistributors = siteDistributors.find((sd) => sd.distributor.distributor === selection.distributorSelected);
            if (!distributorSelectedInSiteDistributors) {
                alert("distributor selected is not associable with current pharmacy");
                return "do not update";
            }
            // Update distributor selected
            this.orderDistributorSelection[selection.inventoryId] =
                selection.distributorSelected;
            const { distributorInventoriesCart = [] } = store_1.inventoryOrderStore;
            const distributorInventoryPrices = distributorInventoriesCart.reduce((acc, cur) => {
                if (!acc[cur.distributor.distributor]) {
                    acc[cur.distributor.distributor] = [cur];
                    return acc;
                }
                acc[cur.distributor.distributor].push(cur);
                return acc;
            }, {});
            // An object to map out the inventory by id to it's respective distributor selection
            // i.e { 6: 'McKesson' }
            this.inventoryDistributorSelection[selection.inventoryId] =
                selection.distributorSelected;
            // Get the price for the distributor selected for an inventory to map to this.inventoryPrices
            const distributorInventoryFound = distributorInventoryPrices[selection.distributorSelected].find((distributorInventory) => distributorInventory.inventory.id === selection.inventoryId);
            this.inventoryPrices[selection.inventoryId] = distributorInventoryFound
                ? distributorInventoryFound.inventoryPrice
                : null;
            this.inventoryImbCosts[selection.inventoryId] = distributorInventoryFound
                ? distributorInventoryFound.imbCost
                : null;
            this.calculateOrderTotalCost();
            this.forceUpdate();
            return "update";
        };
        /**
         * Calculate the order total cost from the distributor selected prices
         * for all inventories.
         */
        this.calculateOrderTotalCost = () => {
            let orderTotalCost = 0;
            for (const id in this.inventoryPrices) {
                if (this.inventoryPrices.hasOwnProperty(id)) {
                    orderTotalCost +=
                        this.inventoryPrices[id] * this.orderReview[id].quantity;
                }
            }
            this.orderTotalCost = orderTotalCost;
        };
        // C-090.6 new quantity update
        this.formatNumberOnly = (number) => {
            return new Intl.NumberFormat().format(number);
        };
        /**
         * Add the quick search inventory and quantity to the order list.
         */
        this.handleAddToOrder = () => {
            // If search field is not empty add/update inventory to/on cart
            if (this.quickSearchSelection && this.quickSearchQuantity !== "") {
                this.orderReview[this.quickSearchSelection.id] = {
                    inventory: this.quickSearchSelection.value,
                    quantity: this.quickSearchQuantity
                };
                this.orderInventory[this.quickSearchSelection.id] = this.quickSearchQuantity;
                this.forceUpdate();
            }
            else if (this.quickSearchQuantity !== "") {
                this.forceUpdate();
            }
            // Clear filter text (from search field) and quick search quantity
            this.filterText = "";
            this.quickSearchQuantity = "";
            // Set quick search selection to null
            this.quickSearchSelection = null;
        };
        this.handleAttachANoteToggle = () => {
            this.attachANote = !this.attachANote;
        };
        /**
         * Generage distribuor inventory prices
         */
        this.generateDistributorInventoryPrices = () => {
            const { distributorInventoriesCart = [] } = store_1.inventoryOrderStore;
            const distributorInventoryPrices = distributorInventoriesCart.reduce((acc, cur) => {
                if (!acc[cur.distributor.id]) {
                    acc[cur.distributor.id] = [cur];
                    return acc;
                }
                // uncessary else after return
                acc[cur.distributor.id].push(cur);
                return acc;
            }, {});
            return distributorInventoryPrices;
        };
        /**
         * Generate current cart
         */
        this.generateCurrentCart = () => {
            const { inventory: { value = [] } } = store_2.inventoryListStore;
            const inventories = ramda_1.flatten(value.map(group => group.children.map(inv => inv)));
            // distrubutorInventoriesCart is an array of objects with the data that links the relationship
            // between inventory id and distributor prices.
            const distributorInventoryPrices = this.generateDistributorInventoryPrices();
            // filter list from the cart...
            this.currentCart = inventories
                .filter((inventory) => this.orderReview[inventory.id] &&
                this.orderReview[inventory.id].quantity !== "0" &&
                this.orderReview[inventory.id].quantity !== "")
                .map((inventory) => (Object.assign(Object.assign({}, inventory), { orderQuantity: this.orderReview[inventory.id].quantity, distributorInventoryPrices })));
        };
        /**
       * method is use to get associate clinic admin and clinic manager users from pharmacies C-036.1 new
       * @param siteId
       */
        this.getUsersOnPurchaseSite = async (siteId) => {
            var _a, _b;
            await store_6.sitesDetailStore.loadUsers({
                allSites: true,
                id: siteId
            });
            await store_5.usersStore.loadPermissionForPOAlert(); // call API to get the data of ReceivedPOAlert category in users permission table.
            const poObj = store_5.usersStore.poReceivedNotification; // get the value of the users in permission who have accees to receive PO alert message in mails.
            (_b = (_a = store_6.sitesDetailStore === null || store_6.sitesDetailStore === void 0 ? void 0 : store_6.sitesDetailStore.users) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.map(item => {
                switch (true) {
                    case item.groupId === permissions_1.GROUPS.ADMIN:
                        item.group.name = "admin";
                        break;
                    case item.groupId === permissions_1.GROUPS.DEV:
                        item.group.name = "dev";
                        break;
                    case item.groupId === permissions_1.GROUPS.MANAGER:
                        item.group.name = "manager";
                        break;
                    case item.groupId === permissions_1.GROUPS.SITE_ADMIN:
                        item.group.name = "siteAdmin";
                        break;
                    case item.groupId === permissions_1.GROUPS.SITE_MANAGER:
                        item.group.name = "siteManager";
                        break;
                    case item.groupId === permissions_1.GROUPS.SITE_USER:
                        item.group.name = "siteUser";
                        break;
                    case item.groupId === permissions_1.GROUPS.SITE_PROVIDER:
                        item.group.name = "siteProvider";
                        break;
                    case item.groupId === permissions_1.GROUPS.DIST_ADMIN: //D-011
                        item.group.name = "distAdmin";
                        break;
                    case item.groupId === permissions_1.GROUPS.DIST_MANAGER: //D-011
                        item.group.name = "distManager";
                        break;
                    case item.groupId === permissions_1.GROUPS.DIST_USER: //D-011
                        item.group.name = "distUser";
                        break;
                    case item.groupId === permissions_1.GROUPS.USER:
                        item.group.name = "user";
                        break;
                }
                if (poObj[item.group.name]) {
                    this.associatedSiteUserEmail.push(item.email);
                }
            });
        };
        /**
         * Handle order review
         */
        // Update to Where Pop Up is Associated C-046.2061 
        this.handleReviewOrder = async () => {
            let cartInventoryIds = Object.keys(this.orderReview);
            this.orderTotalCost = 0;
            // Check for missing distributors
            await this.checkForMissingDistributors(cartInventoryIds);
            // Debugging: Check the contents of storeMissingdistInvt
            // console.log('Missing Distributors:', this.storeMissingdistInvt);
            if (this.storeMissingdistInvt && this.storeMissingdistInvt.length > 0) {
                // Distributor is present
                this.isDistributorAssisgnedInvt = true;
                this.renderDistributorWarningDoubleCheck();
            }
            else {
                // No distributor is present, process order review
                await this.processOrderReview(cartInventoryIds);
            }
            // this.orderReview = {};
        };
        // Update to Where Pop Up is Associated C-046.2061 
        this.renderDistributorWarningDoubleCheck = async () => {
            var _a;
            if (!this.storeMissingdistInvt.length) {
                this.htmlDataForMessage = '';
            }
            else {
                this.htmlDataForMessage = `
      <p>Missing distributor selection from the following inventories:</p>
      <ul>
        ${(_a = this.storeMissingdistInvt) === null || _a === void 0 ? void 0 : _a.map((name) => `<li>${name}</li>`).join('')}
      </ul>
      <p>
        <span>
          The pharmacy does not have a distributor assigned
          that is able to ship these NDCs.
        </span>
      </p>
      <br/>
      <div>
        Before the order can be approved, you will need to assign
        a distributor with these NDCs selected in the inventory.
      </div>
      `;
            }
        };
        // Update to Where Pop Up is Associated C-046.2061 
        this.processOrderReview = async (cartInventoryIds) => {
            try {
                // Ensure cartInventoryIds is not empty before proceeding
                if (!cartInventoryIds || cartInventoryIds.length === 0) {
                    console.error('No items in the cart inventory. Cannot process order review.');
                    return;
                }
                // Load distributor inventories for the cart
                await store_1.inventoryOrderStore.loadDistributorInventoriesCart(cartInventoryIds, this.orderSiteId);
                // console.log('Distributor inventories loaded successfully.', this.orderSiteId);
                // Fetch users on the purchase site
                await this.getUsersOnPurchaseSite(this.orderSiteId); // C-036.1 new
                // Query from SiteDistributor
                await store_1.inventoryOrderStore.loadSiteDistributors(this.orderSiteId);
                // Generate current cart and initialize selection
                this.generateCurrentCart();
                this.initializeDistributorSelection();
                // Set the flag to show order review
                this.showOrderReview = true;
                // Force update the UI
                this.forceUpdate();
            }
            catch (error) {
                console.error('Error processing order review:', error);
                // Optionally, you could set an error state or notify the user here
            }
        };
        // Update to Where Pop Up is Associated C-046.2061 
        this.checkForMissingDistributors = async (cartInventoryIds) => {
            try {
                const fetchDis = await store_1.inventoryOrderStore.loadDistributorInventoryWithDist(cartInventoryIds, this.orderSiteId);
                const dataMissing = fetchDis.filter((item) => item.distributor === null);
                const missingNames = await dataMissing.map((item) => item.inventoryName);
                this.storeMissingdistInvt = missingNames;
            }
            catch (error) {
                console.error("Error checking for missing distributors:", error);
            }
        };
        /**
         * Filter inventories from inventory list based on filtertext
         */
        this.renderFilteredData = () => {
            const activePharm = store_2.inventoryListStore.activePharm;
            const { inventory: { value = [] } } = store_2.inventoryListStore;
            // get the entire inventory list
            const inventories = ramda_1.flatten(value.map(group => group.children.map(inv => inv)));
            // filter out inventories based on activePharm -- if issue occurs, it may have to do with the value of activePharm
            const filteredPharmacyInventories = inventories.filter(inventory => {
                const associatedInventorySite = inventory.sites.some((site) => site.siteId === activePharm);
                const hasAvailableDistributor = inventory.purchaseInventoryDistributor.some((pid) => !pid.isBackorder);
                return associatedInventorySite && hasAvailableDistributor;
            });
            // Filter match inventories based on filter text by accounting for ndc, package, description, and name
            const getMatchedFilterText = (item) => item.label.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1 ||
                item.value.ndc.toLowerCase().indexOf(this.filterText.toLowerCase()) >
                    -1 ||
                item.value.package.toLowerCase().indexOf(this.filterText.toLowerCase()) >
                    -1 ||
                item.value.description
                    .toLowerCase()
                    .indexOf(this.filterText.toLowerCase()) > -1;
            if (store_5.usersStore.user.value.user) {
                return inventories
                    .map((inventory) => ({
                    id: inventory.id,
                    label: `${inventory.package} ${inventory.strengthDescription ||
                        inventory.name}`,
                    value: inventory
                }))
                    .filter(getMatchedFilterText);
            }
            return filteredPharmacyInventories
                .map((inventory) => ({
                id: inventory.id,
                label: `${inventory.package} ${inventory.strengthDescription ||
                    inventory.name}`,
                value: inventory
            }))
                .filter(getMatchedFilterText);
        };
        /**
         * Render the order list from the inventory list
         */
        this.renderOrderList = () => {
            const { inventory: { value = [] } } = store_2.inventoryListStore;
            const inventories = ramda_1.flatten(value.map(group => group.children.map(inv => inv)));
            const filteredPharmacyInventories = inventories.filter((inventory) => {
                const associatedInventorySite = inventory.sites.some((site) => site.siteId === this.orderSiteId);
                // const hasAvailableDistributor = inventory.purchaseInventoryDistributor.some(
                //   (pid: any) => !pid.isBackorder
                // );
                // return associatedInventorySite && hasAvailableDistributor;
                return associatedInventorySite;
            });
            return (React.createElement("div", { className: "edit-order-list" },
                React.createElement(ReactTooltip, { delayShow: 100 }),
                React.createElement(list_1.MaterialList, { columns: columns, order: "ASC", orderBy: "", 
                    // rows={this.inventoryList}
                    rows: filteredPharmacyInventories, renderRow: this.renderOrderListRow, resizableheader: true, customClass: "custom-material-list__quick-order-list" }),
                React.createElement("div", { className: "edit-order-list__preview" },
                    "ORDER REVIEW",
                    React.createElement("div", { className: "edit-order-list__preview--list" },
                        React.createElement(core_1.List, null,
                            React.createElement(list_item_1.MaterialListItem, { className: "order-review-header" }, orderPreviewColumns.map((column, index) => (React.createElement("div", { className: "material-list__header-item", key: index },
                                React.createElement(list_item_text_1.MaterialListItemText, { header: true, primary: column.label }))))),
                            React.createElement("div", { className: "order-review-items" }, this.renderOrderPreviewList && this.renderOrderPreviewList())),
                        React.createElement("div", { className: "review-button" },
                            React.createElement(button_1.MaterialButton, { disabled: this.shouldDisableReviewOrder(), variant: "flat", onClick: this.handleReviewOrder }, "Review Order")))),
                this.isDistributorAssisgnedInvt &&
                    React.createElement("div", { className: "order-popup " },
                        React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Assign Distributor", cancelText: "Cancel", message: this.htmlDataForMessage, onCancel: () => (this.isDistributorAssisgnedInvt = false), onConfirm: () => {
                                const distributorUrl = `/pharmacies/${this.orderSiteId}/distributors`;
                                window.open(distributorUrl, '_blank');
                                this.isDistributorAssisgnedInvt = false;
                            }, isCancelPrimary: false, title: (React.createElement(React.Fragment, null,
                                " ",
                                React.createElement("span", null, "Warning"),
                                " ",
                                React.createElement("br", null),
                                "Unable to Approve Order")), isSubmit: this.storeMissingdistInvt.length ? true : false }))));
        };
        this.shouldDisableReviewOrder = () => {
            const orderListLength = Object.entries(this.orderReview).filter((item) => item[1].quantity !== "0" && item[1].quantity !== "").length;
            if (orderListLength > 0 && this.orderSiteId) {
                return false;
            }
            return true;
        };
        this.renderOrderListRow = (row, index) => {
            let qty = 0;
            const targetIntent = this.purchaseOrderIntents.filter(i => i.inventory.id === row.id)[0];
            if (targetIntent) {
                qty = targetIntent.qtyToOrder;
            }
            const hasAvailableDistributor = row.purchaseInventoryDistributor.some((pid) => !pid.isBackorder);
            const isBackorder = row.isBackorder || !hasAvailableDistributor;
            const inventoryName = row.strengthDescription || row.name || row.generic || "";
            const inventoryDescription = row.description || "";
            return (React.createElement(list_item_1.MaterialListItem, { key: index, className: `order-list-item${isBackorder ? " order-list-item__backorder" : ""}` },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.package }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryDescription) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: this.orderSuggested[row.id] ? this.orderSuggested[row.id] : "" }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(core_1.TextField, { id: "standard-with-placeholder", label: row.quantity, value: this.orderInventory[row.id] || "", placeholder: row.quantiy, disabled: isBackorder, onChange: this.handleQuantityChange(row) }) })));
        };
        this.renderOrderReviewListRow = (row, index) => {
            const activeSite = this.orderSiteId;
            const siteInventory = row.sites.find((site) => site.siteId === activeSite // Changed from inventoryListStore.activePharm
            );
            // C-090.6 new tickets 28/10/2024
            const distributorInventoryPriceSelectString = typeof this.inventoryPrices[row.id] === "number"
                ? `$${this.inventoryPrices[row.id].toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                : "";
            // const distributorInventoryPriceSelectString =
            //   typeof this.inventoryPrices[row.id] === "number"
            //     ? `$${this.inventoryPrices[row.id].toFixed(2)}`
            //     : "";
            // C-090.6 
            const totalCostSelectString = this.inventoryPrices[row.id] &&
                typeof this.inventoryPrices[row.id] === "number"
                ? `$${(this.inventoryPrices[row.id] * row.orderQuantity)
                    .toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                : "";
            // const totalCostSelectString =
            //   this.inventoryPrices[row.id] &&
            //   typeof this.inventoryPrices[row.id] === "number"
            //     ? `$${(this.inventoryPrices[row.id] * row.orderQuantity).toFixed(2)}`
            //     : "";
            const isTmp = store_5.usersStore.user.value.user;
            const inventoryName = row.strengthDescription || row.name || row.generic || "";
            const inventoryDescription = row.description;
            return (React.createElement(list_item_1.MaterialListItem, { key: index, className: "order-list-item" },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.package }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryDescription) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: siteInventory.quantity }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: siteInventory.min }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: siteInventory.max }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(distributor_drop_down_override_1.DistributorDropDownOverride, { selectedDistributor: this.orderDistributorSelection[row.id] || "", inventory: row, siteId: this.orderSiteId, onSelect: this.handleDistributorSelectionOverride, overrideId: siteInventory.defaultDistributorOverrideId }) }),
                isTmp ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: distributorInventoryPriceSelectString || "" })) : null,
                React.createElement(list_item_text_1.MaterialListItemText, { primary: this.formatNumberOnly(row.orderQuantity) }),
                isTmp ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: totalCostSelectString || "" })) : null));
        };
        /**
         * Render order review list for the order cart
         */
        this.renderOrderPreviewList = () => Object.entries(this.orderReview)
            .filter((item) => item[1].quantity !== "0" && item[1].quantity !== "")
            .map((item, index) => (React.createElement(list_item_1.MaterialListItem, { key: index, className: "order-list-item" },
            React.createElement(list_item_text_1.MaterialListItemText, { className: "qty-review", primary: this.formatNumberOnly(item[1].quantity) }),
            React.createElement(list_item_text_1.MaterialListItemText, { primary: item[1].inventory.ndc }))));
        /**
         * Renders the review page section for the quick order
         */
        this.renderOrderReviewList = () => {
            const { inventory: { value = [] } } = store_2.inventoryListStore;
            const inventories = ramda_1.flatten(value.map(group => group.children.map(inv => inv)));
            // distrubutorInventoriesCart is an array of objects with the data that links the relationship
            // between inventory id and distributor prices.
            const { distributorInventoriesCart = [] } = store_1.inventoryOrderStore;
            const distributorInventoryPrices = distributorInventoriesCart.reduce((acc, cur) => {
                if (!acc[cur.distributor.id]) {
                    acc[cur.distributor.id] = [cur];
                    return acc;
                }
                acc[cur.distributor.id].push(cur);
                return acc;
            }, {});
            // filter list from the cart...
            const cart = inventories
                .filter((inventory) => this.orderReview[inventory.id] &&
                this.orderReview[inventory.id].quantity !== "0" &&
                this.orderReview[inventory.id].quantity !== "")
                .map((inventory) => (Object.assign(Object.assign({}, inventory), { orderQuantity: this.orderReview[inventory.id].quantity, distributorInventoryPrices })));
            const isTmp = store_5.usersStore.user.value.user;
            return (React.createElement("div", { className: "edit-review-order-list" },
                React.createElement(list_1.MaterialList, { columns: isTmp ? orderReviewColumnsTmp : orderReviewColumns, order: "ASC", orderBy: "", rows: cart || [], renderRow: this.renderOrderReviewListRow, resizableheader: true, customClass: `custom-material-list__quick-order-review-list${isTmp ? "--tmp" : ""}` })));
        };
    }
    componentWillMount() {
        ReactTooltip.rebuild();
        store_3.sitesListStore.loadSitesNoRelation(); // @tkay load sites no relations
        const { purchaseOrderToEdit, intentOrderMeta } = store_1.inventoryOrderStore;
        if (intentOrderMeta) {
            const { site } = intentOrderMeta;
            this.orderSiteId = site.id;
        }
        else if (purchaseOrderToEdit) {
            const { site } = purchaseOrderToEdit;
            this.orderSiteId = site.id;
        }
        else {
            this.orderSiteId =
                store_5.usersStore.user && store_5.usersStore.user.value && store_5.usersStore.user.value.siteId
                    ? store_5.usersStore.user.value.siteId
                    : 0;
        }
    }
    componentWillUnmount() {
        store_1.inventoryOrderStore.resetIntentOrderMeta();
    }
    /**
     * Check user rank and render inventory list based on active pharmacy if the user is a site user.
     */
    async componentDidMount() {
        ReactTooltip.rebuild();
        await this.loadInventories();
        await store_1.inventoryOrderStore.listDistributors();
        if (store_5.usersStore.user.value.siteUser) {
            const siteId = store_5.usersStore.user.value.site.id;
            store_2.inventoryListStore.activePharm = siteId;
        }
        const { purchaseOrderToEdit, intentOrderMeta } = store_1.inventoryOrderStore;
        if (purchaseOrderToEdit) {
            const { site } = purchaseOrderToEdit;
            this.orderSiteId = site.id;
            try {
                this.initiatePoEdit();
            }
            catch (e) {
                console.error("error in initiating po edit", e);
            }
        }
        else {
            await this.loadPurchaseOrderIntents();
            if (intentOrderMeta) {
                if (this.orderSiteId) {
                    this.initializeGenerateIntentQuickOrder();
                }
                else {
                    alert("Site not selected");
                }
            }
        }
    }
    // B-065
    get availableOptions() {
        const user = store_5.usersStore.user.value || null;
        const showAllSites = store_5.usersStore.permissions.ReadPharmacies;
        if (!store_3.sitesListStore.sites.value) {
            return {
                id: 0,
                label: "Fake",
                value: "0"
            };
        }
        return store_3.sitesListStore.sites.value
            .filter((site, i) => showAllSites ||
            site.id === user.site.id ||
            user.sites.includes(site.id))
            .map((site, i) => ({
            id: i,
            label: site.displayName || site.name,
            value: site.id.toString()
        }));
    }
    render() {
        ReactTooltip.rebuild();
        return store_5.usersStore.permissions.ReadOrder ? (React.createElement(React.Fragment, null,
            this.showOrderReview
                ? this.renderOrderReviewPage()
                : this.renderQuickOrder(),
            this.showAutomateOrderConfirmation
                ? this.renderAutomateOrderConfirmationModal()
                : null,
            this.showQuickOrderScan ? (React.createElement(quick_order_scan_1.QuickOrderScan, { onCancel: () => (this.showQuickOrderScan = false), onSubmit: this.handleScanSubmit })) : null)) : (store_5.usersStore.showLock());
    }
    // C-090.6 
    // Function to format number as currency
    formatNumber(num) {
        return `$${num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    }
    get inventoryList() {
        const { inventory: { value = [] } } = store_2.inventoryListStore;
        const inventories = ramda_1.flatten(value.map(group => group.children.map(inv => inv)));
        const filteredPharmacyInventories = inventories.filter(inventory => inventory.sites.some((site) => site.siteId === this.orderSiteId));
        return filteredPharmacyInventories;
    }
};
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "showMenu", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderInventory", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderSuggested", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderReview", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "quickSearchSelection", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "quickSearchQuantity", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "showOrderReview", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "selectedDistributor", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "distributorInventoryPrices", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "inventoryPrices", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "inventoryImbCosts", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "attachANote", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderTotalCost", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "currentCart", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderDistributorSelection", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderNote", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "associatedSiteUserEmail", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderName", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderDescription", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "transactionPONumber", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "orderSiteId", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "automateOrderUsed", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "showAutomateOrderConfirmation", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "purchaseOrderIntents", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "showQuickOrderScan", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "totalQuantity", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "showConfirmApproveDoubleChecks", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "purchaseOrder", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "isDistributor", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "storeMissingdistInvt", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "htmlDataForMessage", void 0);
__decorate([
    mobx_1.observable
], QuickOrderTab.prototype, "isDistributorAssisgnedInvt", void 0);
__decorate([
    mobx_1.computed
], QuickOrderTab.prototype, "availableOptions", null);
__decorate([
    mobx_1.action
], QuickOrderTab.prototype, "handleQuantityChange", void 0);
__decorate([
    mobx_1.action
], QuickOrderTab.prototype, "handleTransactionPONumberChange", void 0);
__decorate([
    mobx_1.action
], QuickOrderTab.prototype, "handleOrderNoteChange", void 0);
__decorate([
    mobx_1.action
], QuickOrderTab.prototype, "handleOrderNameChange", void 0);
__decorate([
    mobx_1.action
], QuickOrderTab.prototype, "handleOrderDescriptionChange", void 0);
__decorate([
    mobx_1.action
], QuickOrderTab.prototype, "handleChangeSite", void 0);
__decorate([
    mobx_1.computed
], QuickOrderTab.prototype, "inventoryList", null);
QuickOrderTab = __decorate([
    mobx_react_1.observer
], QuickOrderTab);
exports.QuickOrderTab = QuickOrderTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/quick-order/quick-order.tsx
// module id = 3599
// module chunks = 0